import React, { useEffect } from 'react';
import { createBrowserRouter, RouterProvider, createRoutesFromElements, Outlet, Route } from 'react-router-dom';

// styles
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.css';
import './assets/css/elementor_style.css';
import './assets/css/swiper-bundle.min.css';
import 'overlayscrollbars/css/OverlayScrollbars.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/css/bootstrap.min.css';
import './assets/css/spartan.css';
import './assets/sass/style.scss';

// pages
import About from './Pages/About';
import Contact from './Pages/Contact';
import Error404 from './Pages/Error404';
import Home1 from './Pages/Home1';
import Projects1 from './Pages/Projects1';
import ServicesStyle1 from './Pages/ServicesStyle1';
import ServicesStyle2 from './Pages/ServiceStyle2';
import ProjectDetailed from './Pages/ProjectDetailed';
import Bloglist from './Pages/Bloglist';
import BlogDetailed from './Pages/BlogDetailed';
import Preloader from './components/Misc/Preloader';
import Navbar from './components/Navs/Navbar';
import Footer from './components/Misc/Footer';
import { initializePage } from './utils';

import ScrollToTop from './components/Misc/ScrollToTop';

const Layout = () => {
    return (
        <>
            <ScrollToTop />
            <Navbar />
            <Outlet />
            <Footer />
        </>
    );
};

const router = createBrowserRouter(
    createRoutesFromElements(
        <Route path="/" element={<Layout />}>
            <Route index element={<Home1 />} />
            <Route path="home" element={<Home1 />} />
            <Route path="about" element={<About />} />
            <Route path="services" element={<ServicesStyle2 />} />
            <Route path="impact" element={<Projects1 />} />
            <Route path="impact/:slug" element={<ProjectDetailed />} />
            <Route path="get-involved" element={<ServicesStyle1 />} />
            <Route path="activities" element={<Bloglist />} />
            <Route path="activities/:slug" element={<BlogDetailed />} />
            <Route path="contact" element={<Contact />} />
            <Route path="*" element={<Error404 />} />
        </Route>
    ),
    {
        basename: "/",
    }
);

export default function App() {
    useEffect(initializePage, []);

    return (
        <div className="App">
            <Preloader />
            <RouterProvider router={router} />
        </div>
    );
}
